import { render, staticRenderFns } from "./Gallery2.vue?vue&type=template&id=11434fa1&scoped=true"
import script from "./Gallery2.vue?vue&type=script&lang=js"
export * from "./Gallery2.vue?vue&type=script&lang=js"
import style0 from "./Gallery2.vue?vue&type=style&index=0&id=11434fa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11434fa1",
  null
  
)

export default component.exports